<!--
 * @Description: 完善资料
-->
<template>
  <div class="perfect_info">
    <NavBar
      :title="$t(`webapp.menus.${$route.meta.field}`)"
      :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()"
      nav-bar-icon-color="#000"
      class="navbarSelf"
    ></NavBar>

    <div class="box-title">
      <Icon name="info-o" size="16" style="margin-right: 5px" />
      {{ $t("login.perfect_info.tip") }}
    </div>

    <Form class="vertical_self_form" @submit="onSubmit">
      <Field
        v-if="basicSetInfo.sjh != 3"
        v-model="form.sjh"
        name="sjh"
        :label="$t('base.mobile.label')"
        :placeholder="$t('base.mobile.placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[
          { required: basicSetInfo.sjh == 1 },
          { pattern: /^1[3456789]\d{9}$/, message: $t('base.mobile.error_tip') },
        ]"
      >
      </Field>
      <Field
        v-if="basicSetInfo.yx != 3"
        v-model="form.yx"
        name="yx"
        :label="$t('base.email.label')"
        :placeholder="$t('base.email.placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[
          { required: this.basicSetInfo.yx == 1 },
          {
            pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
            message: $t('base.email.error_tip'),
          },
        ]"
      >
      </Field>
      <Field
        readonly
        clickable
        v-if="basicSetInfo.sr != 3"
        v-model="form.sr"
        name="sr"
        :label="$t('login.perfect_info.birth_label')"
        :placeholder="$t('login.perfect_info.birth_placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        @click="birthPicker = true"
        style="margin-bottom: 10px"
        :rules="[
          {
            required: this.basicSetInfo.sr == 1 ? true : false,
          },
        ]"
      >
      </Field>
      <Popup v-model="birthPicker" position="bottom">
        <DatetimePicker
          v-model="currentDate"
          type="date"
          :title="$t('webapp.login.perfect_info.chose_birth')"
          :min-date="minDate"
          @confirm="onConfirmDate"
          @cancel="birthPicker = false"
        />
      </Popup>
      <template v-if="basicSetInfo.aqwt != 3">
        <template v-for="(item, index) in form.questionVos">
          <Field
            readonly
            clickable
            v-model="item.questionName"
            :key="`qus${index}`"
            :label="`${$t('base.question.label')}${index + 1}`"
            :name="'questionVos.' + index + '.question'"
            :show-error-message="false"
            :scroll-to-error="true"
            @click="handleQuestion(index)"
            :rules="[
              {
                required: basicSetInfo.aqwt == 1,
                message: $t('base.question.question_placeholder'),
              },
            ]"
          >
          </Field>
          <Field
            v-model="item.answer"
            :key="`ans${index}`"
            :label="`${$t('base.question.answer')}${index + 1}`"
            :name="'questionVos.' + index + '.answer'"
            :rules="[{ required: basicSetInfo.aqwt == 1, message: $t('base.question.placeholder') }]"
          >
          </Field>
        </template>
      </template>
      <ActionSheet v-model="questionSheet" :actions="qusArr2" @select="handleSelect"> </ActionSheet>
      <div style="margin: 30px 0">
        <Button round block type="info" native-type="submit">{{ $t("base.btn.save") }}</Button>
        <Button style="margin-top: 10px" round block @click="goLogin">{{ $t("base.btn.back_login") }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { NavBar, Popup, Icon, Form, Field, Button, DatetimePicker, ActionSheet } from "vant";
import { commonAPI } from "@/apis";
import moment from "moment";
import { commonMethods } from "./mixins/common";
import { toast } from "@/utils/toast";

export default {
  name: "PerfectInfo",
  components: { NavBar, Popup, Icon, Form, Field, Button, DatetimePicker, ActionSheet },
  mixins: [commonMethods],
  data() {
    return {
      qusArr: [],
      form: {
        sjh: "",
        yx: "",
        sr: "",
        questionVos: [
          { question: undefined, answer: "" },
          { question: undefined, answer: "" },
          { question: undefined, answer: "" },
        ],
      },
      basicSetInfo: {},
      before_login: {},
      birthPicker: false,
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      questionSheet: false,
      currentIndex: 0,
    };
  },
  computed: {
    qusArr2() {
      let arr = this.qusArr;
      arr.forEach((el) => {
        let item = this.form.questionVos.find((o) => o.question == el.id);
        el.disabled = item ? true : false;
      });
      return arr;
    },
  },
  created() {
    // 获取登录配置
    let basicSetInfo = sessionStorage.getItem("BASIC_SET_INFO");
    this.basicSetInfo = basicSetInfo ? JSON.parse(basicSetInfo) : {};

    // 判断是否浏览器回退前进进入
    let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
    if (!before_login || !before_login.showInfo) {
      this.$router.replace({ path: "/mlogin" });
    } else {
      this.before_login = { ...before_login };
    }

    this.getDefaultInfo();
  },
  methods: {
    // 获取默认密保
    async getDefaultInfo() {
      const { code, data } = await commonAPI.getAction("/user/password/question/getAll");
      if (code == 0) {
        this.qusArr =
          data.map((v) => ({
            ...v,
            name: v.question,
          })) || [];
      }
    },
    // 保存当前点击问题的索引
    handleQuestion(index) {
      this.currentIndex = index;
      this.questionSheet = true;
    },
    // 当前选择的问题
    handleSelect(v) {
      let item = this.form.questionVos[this.currentIndex];
      item.question = v.id;
      item.questionName = v.name;
      this.questionSheet = false;
    },
    // 选择日历
    onConfirmDate(value) {
      this.form.sr = moment(value).format("YYYY-MM-DD");
      this.birthPicker = false;
    },
    onSubmit() {
      let params = [];
      let obj = this.form;
      for (const key in obj) {
        if (key == "questionVos") {
          params.push({
            filter: "aqwt",
            classify: this.basicSetInfo["aqwt"],
            questionVos: obj[key],
          });
        } else {
          params.push({
            filter: key,
            val: obj[key],
            classify: this.basicSetInfo[key],
          });
        }
      }
      this.handleOkApi(params);
    },
    async handleOkApi(params) {
      const { code, message } = await commonAPI.postAction(`/users/update/${this.user.username}`, params);
      if (code == 0) {
        toast(message);
        this.before_login.showInfo = false;
        sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
        this.jumpComputed();
      } else {
        toast(message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
.flex {
  display: flex;
  align-items: center;
}
.box-title {
  background: #fff8ee;
  border: 1px solid rgba(255, 152, 0, 0.19);
  color: #ff9800;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  padding: 5px;
  @extend .flex;
}
</style>
